import { ISecurityAppActionData } from '.';

export interface ISecurityAccessRoleData {
  accessRoleId: string;
  accessRoleName: string;
  accessRoleLevel: number;

  appActions: ISecurityAppActionData[];
}
